import Connector from '@nextories/vue-core-components/src/utils/Api';

export default class MoverAPi extends Connector {
  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */

  getTags() {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('get', 'movertags');
  }
}